import { render, staticRenderFns } from "./ItemChip.vue?vue&type=template&id=33753e63&scoped=true"
import script from "./ItemChip.vue?vue&type=script&lang=ts"
export * from "./ItemChip.vue?vue&type=script&lang=ts"
import style0 from "./ItemChip.vue?vue&type=style&index=0&id=33753e63&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33753e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33753e63')) {
      api.createRecord('33753e63', component.options)
    } else {
      api.reload('33753e63', component.options)
    }
    module.hot.accept("./ItemChip.vue?vue&type=template&id=33753e63&scoped=true", function () {
      api.rerender('33753e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChip.vue"
export default component.exports